import {setLocalStorageItem} from '../localStorage';
import map from 'lodash/map';
import difference from 'lodash/difference';
import intersectionBy from 'lodash/intersectionBy';
import fetchJSON from '../fetchJSON';
import isEqual from 'lodash/isEqual';
import uniqBy from 'lodash/uniqBy';
import fetchUser from './fetchUser';
import {AddSavePromise} from '../../hooks/useIsSaved';
import trackLayerAnalytics from './trackLayerAnalytics';

export default async function saveLayers(
    userLayers: UserLayer[],
    savedUserLayers: UserLayer[] | null = null,
    erroredUserLayers: UserLayer[] | null = null,
    addSavePromise: AddSavePromise,
): Promise<UserLayer[]> {

    const user = await fetchUser();
    if (!user.isAuthenticated) return userLayers;

    if (isEqual(userLayers, savedUserLayers)) return userLayers;
    if (isEqual(userLayers, erroredUserLayers)) return userLayers;

    trackLayerAnalytics('Set Map Source', userLayers, {category: 'map2'});
    setLocalStorageItem('userLayers', userLayers);

    const layerTypes = map(userLayers, 'layer.type');
    const savedLayerTypes = map(savedUserLayers, 'layer.type');

    const addLayerTypes = difference(layerTypes, savedLayerTypes);
    const removeLayerTypes = difference(savedLayerTypes, layerTypes);

    if (addLayerTypes.length === 0 && removeLayerTypes.length === 0) return userLayers;

    const response = await addSavePromise(fetchJSON('/api/objects/mapSource/selection/', {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({add: addLayerTypes, remove: removeLayerTypes})
    }));

    const nextUserLayers = response.map(({uniqueTilecacheKey}: {uniqueTilecacheKey: string}) => ({
        layer: {
            type: uniqueTilecacheKey,
            opacity: 1,
        },
        isVisible: false
    }));

    return uniqBy([
        ...intersectionBy(userLayers, nextUserLayers, 'layer.type'),
        ...nextUserLayers
    ], 'layer.type');
}
